module.exports = __webpack_public_path__ + "static/media/icon-beauty.2777e866.png";